import { graphql, useStaticQuery } from 'gatsby'

import { Hidden } from '@material-ui/core'
import React from 'react'
import View from './Navigation.view'

type StateProps = {
    location: Location
}

export default ({ location }: StateProps) => {
    const data = useStaticQuery(graphql`
        query HeaderQuery {
            allContentfulInstitution {
                nodes {
                    ...institutionFragment
                }
            }
        }
    `)

    return (
        <>
            <Hidden mdUp>
                <View
                    institutions={data.allContentfulInstitution.nodes}
                    location={location}
                    isExpandable={true}
                />
            </Hidden>
            <Hidden smDown>
                <View
                    institutions={data.allContentfulInstitution.nodes}
                    location={location}
                    isExpandable={false}
                />
            </Hidden>
        </>
    )
}
